import { useEffect } from 'react';
import { useIoContext } from '~/providers/IoContext';
import { useFeatureFlags } from './useFeatureFlags';
export const useNativePush = ()=>{
    const { native } = useIoContext();
    const { NATIVE_PUSH } = useFeatureFlags();
    const pushEnabled = !!NATIVE_PUSH && native.push.isAvailable;
    useEffect(()=>{
        if (pushEnabled) {
            const { push } = native;
            const removeListenersPromise = push.registerTokenLogging();
            void removeListenersPromise.then(()=>push.requestPermissionAndRegister()).catch(()=>undefined);
            return ()=>{
                void removeListenersPromise.then((removeListeners)=>removeListeners()).catch(()=>undefined);
            };
        }
        return undefined;
    }, [
        pushEnabled
    ]);
};
